/*
  CSW Default Product Enhancement JS
  Safely converts the default product description into a collapsible block.
  It does not touch product forms, product option apps, review apps, or add-to-cart logic.
*/
if (document.documentElement.dataset.cswProductTemplate === 'in-stock-wraps') {
  console.log('CSW description accordion disabled for in-stock template');
} else {

(() => {
  const selectors = [
    '.product__description',
    '.product-single__description',
    '[data-product-description]'
  ];

  const initDescriptionCollapse = (root = document) => {
    const description = selectors
      .map((selector) => root.querySelector(selector))
      .find(Boolean);

    if (!description || description.dataset.cswCollapsed === 'true') return;
    if (description.closest('.csw-desc-details')) return;
    if (!description.textContent.trim()) return;

    description.dataset.cswCollapsed = 'true';

    const details = document.createElement('details');
    details.className = 'csw-desc-details';

    const summary = document.createElement('summary');
    summary.textContent = 'Product Description';

    const panel = document.createElement('div');
    panel.className = 'csw-desc-panel';

    const inner = document.createElement('div');
    inner.className = 'csw-desc-inner';

    description.parentNode.insertBefore(details, description);
    inner.appendChild(description);
    panel.appendChild(inner);
    details.appendChild(summary);
    details.appendChild(panel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initDescriptionCollapse());
  } else {
    initDescriptionCollapse();
  }

  document.addEventListener('shopify:section:load', (event) => initDescriptionCollapse(event.target));
})();
}
